import React, { Suspense, lazy } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Critical components - load immediately
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";

// Lazy load below-fold components for faster initial load
const MissionSection = lazy(() => import("./components/MissionSection"));
const ServicesSection = lazy(() => import("./components/ServicesSection"));
const AgniScoreSection = lazy(() => import("./components/AgniScoreSection"));
const DoctorsSection = lazy(() => import("./components/DoctorsSection"));
const HealingJourneySection = lazy(() => import("./components/HealingJourneySection"));
const PackagesSection = lazy(() => import("./components/PackagesSection"));
const TestimonialsSection = lazy(() => import("./components/TestimonialsSection"));
const BlogSection = lazy(() => import("./components/BlogSection"));
const ContactSection = lazy(() => import("./components/ContactSection"));
const Footer = lazy(() => import("./components/Footer"));
const BlogPage = lazy(() => import("./components/BlogPage"));
const BlogListPage = lazy(() => import("./components/BlogListPage"));
const BookConsultationPage = lazy(() => import("./components/BookConsultationPage"));
const AgniScorePage = lazy(() => import("./components/AgniScorePage"));
const AdminDashboard = lazy(() => import("./components/AdminDashboard"));
const DietFeedbackPage = lazy(() => import("./components/DietFeedbackPage"));
const AgniScorePopup = lazy(() => import("./components/AgniScorePopup"));
const FloatingAgniButton = lazy(() => import("./components/FloatingAgniButton"));
const PaymentPage = lazy(() => import("./components/PaymentPage"));
const PaymentResultPage = lazy(() => import("./components/PaymentResultPage"));

// Loading fallback component
const LoadingFallback = () => (
  <div className="flex items-center justify-center py-12">
    <div className="w-8 h-8 border-4 border-[#205781]/20 border-t-[#205781] rounded-full animate-spin"></div>
  </div>
);

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <HeroSection />
      <Suspense fallback={<LoadingFallback />}>
        <MissionSection />
        <AgniScoreSection />
        <ServicesSection />
        <DoctorsSection />
        <HealingJourneySection />
        <PackagesSection />
        <TestimonialsSection />
        <BlogSection />
        <ContactSection />
        <Footer />
        <AgniScorePopup />
        <FloatingAgniButton />
      </Suspense>
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Suspense fallback={<LoadingFallback />}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/book-consultation" element={<BookConsultationPage />} />
            <Route path="/agni-score" element={<AgniScorePage />} />
            <Route path="/blog" element={<BlogListPage />} />
            <Route path="/blog/:slug" element={<BlogPage />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/diet-feedback/:token" element={<DietFeedbackPage />} />
            <Route path="/pay" element={<PaymentPage />} />
            <Route path="/payment-result" element={<PaymentResultPage />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
}

export default App;
